import React from "react"
import EcosuiteComponent, { Loading, Error } from "@common/EcosuiteComponent"
import EnergyUtils from "@dashboard/energy/EnergyUtils"

export default class PredictedConsumption extends EcosuiteComponent {
  renderContent() {
    if (this.isContentError(this.props.predictedConsumption)) {
      return <Error error={this.props.predictedConsumption.getError()} />
    }
    if (this.isContentValid(this.props.predictedConsumption) && this.props.predictedConsumption.predictedConsumption !== undefined) {
      return <div className="sidebar-heading">{EnergyUtils.displayWattHours(this.props.predictedConsumption.predictedConsumption)}</div>
    } else {
      return <Loading />
    }
  }
}
